<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    :modal="false"
    :title="'新增批号'"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submita"
      />
  </el-dialog>
</template>

<script>
import { GoodsService } from '../../service/goods.service';
import moment from 'moment';
  export default {
    name: 'formBatchNumber',
    data() {
      return {
        openType: 'add',
        visible: false,
        defaultValues: {},
        rules: {
          batch_no: [{ required: true, message: '批号不能为空'}],
          img: [{ required: true, message: '报告书不能为空'}],
          batch_sn: [{ required: true, message: '批次不能为空'}],
          expiration_data: [{ required: true, message: '请选择过期时间'}],
        },
        formFields: [
          { type: 'input', key: 'batch_no', label: '批号', span: 24 },
          { type: 'image', key: 'img', label: '报告书', span: 24, pathType: 'batch', limit: 1 },
          { type: 'input', key: 'batch_sn', label: '批次', span: 24 },
          { type: 'date', key: 'expiration_date', label: '过期时间', span: 24 },
        ],
        goodsData: {},
      }
    },
    methods: {
      open(data, openType) {
        this.goodsData = data;
        this.openType = openType;
        if (openType === 'edit') {
          const fomatData = {...data};
          fomatData.expiration_date = moment(data.fomatData);
          fomatData.img = [{
            uid: '1',
            name: '图片异常',
            status: 'done',
            url: GoodsService.spliceImg(fomatData.img),
          }];
          this.defaultValues = fomatData;
        } else {
          this.defaultValues = {};
        }
        this.visible = true;
      },
      cancel() {
        this.visible = false;
      },
      async submita(data) {
        data.goods_id = this.goodsData.goods_id;
        await GoodsService.saveBatchNumber(data, this.openType);
        this.$emit('success');
        this.cancel();
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>